<div class="find" *transloco="let t; read:'permit.team.search'">

    <div *ngIf="currentView === View.Start" class="find__find-menu">
        <div class="find__find-menu__title">{{t('find.title')}}</div>
        <button class="find__find-menu__option find__find-menu__option--heta" (click)="changeView(View.Concept1)">
            <img class="heta--svg" src="assets/images/icons/heta-bird.svg">
            <span [innerHTML]="t('find.concept1')"></span>
        </button>
        <button class="find__find-menu__option" (click)="changeView(View.Concept2)">{{t('find.concept2')}}</button>
        <button class="find__find-menu__option" (click)="changeView(View.Other)">{{t('find.otherCountry')}}</button>
    </div>

    <button class="find__back-button" *ngIf="currentView !== View.Start && allowExternalCertificates" (click)="goBack()"></button>

    <div *ngIf="currentView === View.Concept1" class="find__find-menu">
        <div class="find__find-menu__title" [innerHTML]="t('find.concept1')"></div>
        <div class="find__information" [innerHTML]="t('find.searchConcept1')"></div>
        <search-box class="find__search-box" (triggerSearch)="search($event)" [ngModel]="query$ | async" [placeholder]="t('find.searchBoxPersonalNumberCustomerId')">
        </search-box>

        <button *ngIf="!isDesktop" class="find__scan-card-button" (click)="openScanCardModal()">{{ t("openScanCardModal") }}</button>
        <div *ngIf="!isQueryValid" class="find__search-error-message">{{ t("errorMessages.invalidPnrOrCustomerId") }}</div>
    </div>

    <div *ngIf="currentView === View.Concept2" class="find__find-menu">
        <div class="find__find-menu__title" [innerHTML]="t('find.concept2')"></div>
        <div class="find__information" [innerHTML]="t('find.searchConcept2')"></div>
        <search-box class="find__search-box" (triggerSearch)="search($event)" [ngModel]="query$ | async" [placeholder]="t('find.searchBoxCertificate')">
        </search-box>
        <div (click)="openCertificateIdentifierHintModal($event)" class="find__find-menu__message" [innerHtml]="t('certificateIdentifierHint')"></div>
        <div *ngIf="!isQueryValid" class="find__search-error-message">{{ t("errorMessages.invalidCertId") }}</div>
    </div>

    <div *ngIf="currentView === View.Concept3" class="find__find-menu">
        <div class="find__find-menu__title" [innerHTML]="t('find.concept3')"></div>
        <div class="find__information" [innerHTML]="t('find.searchConcept3')"></div>
        <search-box class="find__search-box" (triggerSearch)="search($event)" [ngModel]="query$ | async" [placeholder]="t('find.searchBoxEmail')">
        </search-box>

        <div *ngIf="!isQueryValid" class="find__search-error-message">{{ t("errorMessages.invalidEmail") }}</div>
    </div>

    <div *ngIf="currentView === View.Concept4" class="find__find-menu">
        <div class="find__find-menu__title" [innerHTML]="t('find.concept4')"></div>
        <div class="find__information" [innerHTML]="t('find.searchConcept45')"></div>
        <search-box class="find__search-box" (triggerSearch)="search($event)" [ngModel]="query$ | async" [placeholder]="t('find.searchBoxCard')">
        </search-box>

        <div *ngIf="!isQueryValid" class="find__search-error-message">{{ t("errorMessages.invalidCardNr") }}</div>
    </div>

    <div *ngIf="currentView === View.Concept5" class="find__find-menu">
        <div class="find__find-menu__title" [innerHTML]="t('find.concept5')"></div>
        <div class="find__information" [innerHTML]="t('find.searchConcept45')"></div>
        <search-box class="find__search-box" (triggerSearch)="search($event)" [ngModel]="query$ | async" [placeholder]="t('find.searchBoxCard')">
        </search-box>

        <div *ngIf="!isQueryValid" class="find__search-error-message">{{ t("errorMessages.invalidCardNr") }}</div>
    </div>

    <div [hidden]="currentView !== View.Concept2ByPersonNumber" class="find__find-menu">
        <div class="find__find-menu__title" [innerHTML]="t('find.concept2')"></div>
        <div class="find__information" [innerHTML]="t('find.searchConcept2ByPersonalNumber')"></div>
        <search-box #query class="find__search-box" (triggerSearch)="search($event)" [ngModel]="query$ | async" [placeholder]="t('find.searchBoxPersonalNumber')" [readOnlyOnDisabled]="true">
        </search-box>
        <ha-checkbox #checkbox [(ngModel)]="hasForeignPersonalNumber" [ngModelOptions]="{standalone: true}"(change)="setHasForeignPersonalNumber()" [label]="t('find.noPersonalNumber')"></ha-checkbox>

        <div *ngIf="hasForeignPersonalNumber">
            <hr class="find__search-result__divider" />
            <div class="find__information__hasForeignPersonalNumber" [innerHTML]="t('find.noPersonalNumberWarning')"></div>
            <button class="find__search-result__create-cert" (click)="changeView(View.CreateCertificate);startCreate = true;">{{ t('find.createCertificate') }}</button>
        </div>

        <div *ngIf="!isQueryValid" class="find__search-error-message">{{ t("errorMessages.invalidPnr") }}</div>
    </div>

    <div *ngIf="currentView === View.CreateCertificate" class="find__find-menu">
        <div class="find__find-menu__title" [innerHTML]="t('find.createCertificate')"></div>
        <pmt-create-new-person [permitId]="permitId" [role]="role"></pmt-create-new-person>
    </div>

    <div *ngIf="currentView === View.Other" class="find__find-menu">
        <div class="find__find-menu__title" [innerHTML]="t('find.otherCountryTitle')"></div>
        <button class="find__find-menu__option" (click)="changeView(View.Concept4)">{{t('find.concept4')}}</button>
        <button class="find__find-menu__option" (click)="changeView(View.Concept5)">{{t('find.concept5')}}</button>
        <button class="find__find-menu__option" (click)="changeView(View.Concept3)">{{t('find.concept3')}}</button>
        <button *ngIf="isPremium && allowExternalCertificates" class="find__find-menu__option" (click)="currentConcept = ConceptType.Other; changeView(View.CreateCertificate)">{{t('find.concept6')}}</button>
    </div>

    <div class="find__search-result" *ngIf="!startCreate && currentView !== View.Start && searchResult$ | async as searchResult">
        <pmt-stage-person *ngIf="searchResult.person && currentView !== View.Concept2ByPersonNumber" [person]="searchResult.person" [permitId]="permitId" [role]="role" (createCertificate)="createCertificate($event)">
        </pmt-stage-person>

        <div *ngIf="searchResult.person && currentView === View.Concept2ByPersonNumber" class="find__search-result__person">
            <hr class="find__search-result__divider" />
            <div>{{t("find.searchResultFoundGet")}}</div>
            <button class="find__search-result__create-cert" (click)="changeViewWithFoundPerson(View.CreateCertificate);startCreate = true;">{{ t('find.get') }}</button>
        </div>

        <div class="find__search-result__error" *ngIf="searchResult.errorMessage">
            <div *ngIf="currentView == View.Concept1" [innerHtml]="t('errorMessages.hetaNotFound')"></div>
            <ng-container *ngIf="currentView >= View.Concept2ByPersonNumber && currentView <= View.Concept5">
                <div *ngIf="searchResult.errorMessage == 'notfound'">
                    <hr class="find__search-result__divider" />
                    <div>{{t("find.searchResultNotFound." + currentConcept)}}</div>
                    <button class="find__search-result__create-cert" (click)="changeView(View.CreateCertificate);startCreate = true;">{{ t('find.createCertificate') }}</button>                </div>
            </ng-container>
        </div>
    </div>
</div>
